module.exports = new __parcel__URL__("star_wolf_silhouette_v2.6e8e98b3.png").toString();